import React from 'react';
import { isProviderType } from '../../util/userHelpers';
import AccessWrapper from './AccessWrapper';

const ProviderRestrictedWrapper = props => {
  const { currentUser, fallback = null, children } = props;
  const hasAccess = !isProviderType(currentUser);

  return (
    <AccessWrapper hasAccess={hasAccess} fallback={fallback}>
      {children}
    </AccessWrapper>
  );
};

export default ProviderRestrictedWrapper;
